<template>
  <div>
    <section class="">
      <div class="container">
        <ul class="btn-box">
          <li>
            <router-link :to="{ name: 'MemberInfo' }" tag="button">
              <img src="img/member-icon-1.svg" alt="" />
              {{ $t("會員資料") }}
            </router-link>
          </li>
          <li>
            <router-link :to="{ name: 'OrderList' }" tag="button">
              <img src="img/member-icon-2.svg" alt="" />
              {{ $t("我的套票") }}
            </router-link>
          </li>
          <li v-if="local != 'jp'">
            <router-link :to="{ name: 'CardInfo' }" tag="button">
              <img src="img/member-icon-6.svg" alt="" />
              {{ $t("卡片資料") }}
            </router-link>
          </li>
          <li>
            <router-link :to="{ name: 'Coupon' }" tag="button" class="active">
              <img src="img/member-icon-8.svg" alt="" />
              {{ $t("套票兌換") }}
            </router-link>
          </li>
          <li>
            <router-link :to="{ name: 'TradeRecord' }" tag="button">
              <img src="img/member-icon-4.svg" alt="" />
              {{ $t("卡片交易紀錄") }}
            </router-link>
          </li>
          <li v-if="local != 'jp'">
            <router-link :to="{ name: 'CarbonReduction' }" tag="button">
              <img src="img/member-icon-9.png" alt="" />
              {{ $t("減碳計算") }}
            </router-link>
          </li>
          <li></li>
        </ul>
        <div class="main">
          <div class="bg-box">
            <h1>{{ $t("套票兌換") }}</h1>
          </div>

          <div class="bg-box">
            <div>
              <h2>{{ $t("兌換說明") }}</h2>
              <hr />
              <p>
                {{
                  $t(
                    "商品券完成兌換後，套票將存入您的會員帳戶內，可依自身需求點選「立即啟用」啟用套票。"
                  )
                }}
                {{ $t("套票兌換完成後即無法辦理退費或轉贈。") }}
              </p>
            </div>

            <div class="coupon-box">
              <h2>{{ $t("商品券序號") }}</h2>
              <input type="text" v-model="couponCode" />
              <button @click="gotoPay">{{ $t("確認兌換") }}</button>
            </div>
          </div>

          <hr />

          <div class="bg-box">
            <div v-html="CouponContent"></div>
          </div>
        </div>
      </div>
    </section>
    <!-- 底部加高 底部固定選單fixed的高度 -->
    <div class="nav-menu-bg"></div>
  </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import VueI18n from "vue-i18n";
import Storage from "@/utils/storage.js";

Vue.use(VueAxios, axios);
Vue.use(VueI18n);

// this.$t("立即購買")
const messages = {
    zh_tw: {
    "會員資料": "會員資料",
    "我的套票": "我的套票",
    "卡片資料": "卡片資料",
    "套票兌換": "套票兌換",
    "卡片交易記錄": "卡片交易記錄",
    "其他資訊": "其他資訊",
    "兌換說明": "兌換說明",
    "商品券完成兌換後，套票將存入您的會員帳戶內，可依自身需求點選「立即啟用」啟用套票。": "商品券完成兌換後，套票將存入您的會員帳戶內，可依自身需求點選「立即啟用」啟用套票。",
    "套票兌換完成後即無法辦理退費或轉贈。": "套票兌換完成後即無法辦理退費或轉贈。",
    "商品券序號": "商品券序號",
    "確認兌換": "確認兌換",
    "錯誤": "錯誤",
    "請輸入商品劵序號": "請輸入商品劵序號",
    "確定": "確定",
    "請稍候...": "請稍候...",
    "訂單建立過程發生錯誤, 請稍後再試一次": "訂單建立過程發生錯誤, 請稍後再試一次",
    "交易完成": "交易完成",
    "交易類型錯誤, 請稍後再試一次(-1)": "交易類型錯誤, 請稍後再試一次(-1)",
    "卡片交易紀錄": "卡片交易紀錄",
    "減碳計算": "減碳計算",
  },
  en: {
    "會員資料": "Member info",
    "我的套票": "My pass",
    "卡片資料": "Card info",
    "套票兌換": "Redeem pass",
    "卡片交易記錄": "Card record",
    "其他資訊": "Other info",
    "兌換說明": "Redemption descriptions",
    "商品券完成兌換後，套票將存入您的會員帳戶內，可依自身需求點選「立即啟用」啟用套票。": "After the coupon is redeemed, the pass will be deposited into your account and you can click \" Enable \" to activate the pass when necessary.",
    "套票兌換完成後即無法辦理退費或轉贈。": "Refund or transfer will not be available after the redemption of the pass.",
    "商品券序號": "Coupon number",
    "確認兌換": "Confirm",
    "錯誤": "Error",
    "請輸入商品劵序號": "Please enter the coupon number",
    "確定": "Confirm",
    "請稍候...": "Wait a second",
    "訂單建立過程發生錯誤, 請稍後再試一次": "Error. Please try again.",
    "交易完成": "Thank you",
    "交易類型錯誤, 請稍後再試一次(-1)": "Error. Please try again. (-1)",
    "卡片交易紀錄": "Activity",
    "減碳計算": "Carbon Reduced",
  },
  jp: {
    "會員資料": "マイページ",
    "我的套票": "購入/予約履歴",
    "卡片資料": "卡片資料",
    "套票兌換": "フリーパス引き換え",
    "卡片交易記錄": "カード取引履歴",
    "其他資訊": "其他資訊",
    "兌換說明": "引き換え説明位",
    "商品券完成兌換後，套票將存入您的會員帳戶內，可依自身需求點選「立即啟用」啟用套票。": "フリーパス引き換え完了後、チケットはマイページ内に保存され、必要に応じて「今すぐ使用する」をクリックし、使用することができます",
    "套票兌換完成後即無法辦理退費或轉贈。": "フリーパス引き換え完了後、返金又は転送することはできません",
    "商品券序號": "フリーパス番号",
    "確認兌換": "引き換え確認",
    "錯誤": "エラー",
    "請輸入商品劵序號": "フリーパス番号を入力してください",
    "確定": "確定",
    "請稍候...": "しばらくお待ちください",
    "訂單建立過程發生錯誤, 請稍後再試一次": "購入手続き中にエラーが発生しました,時間をおいてから再度お試しください",
    "交易完成": "ご注文が完了しました",
    "交易類型錯誤, 請稍後再試一次(-1)": "ご注文を処理中にエラーが発生しました,時間をおいてから再度お試しください",
    "卡片交易紀錄": "カード取引履歴",
    "減碳計算": "減碳計算",
  },
};

const i18n = new VueI18n({
  locale: "zh_tw",
  messages,
});

export default {
  name: "Coupon",
  i18n,
  data() {
    return {
      CouponContent: "",
      couponCode: "",
      local: "zh_tw",
    };
  },
  created: function () {
    Vue.axios
      .get(this.GLOBAL.apiSrc + this.GLOBAL.subDirectory + "/Htmlv2/Coupon", {
        params: { lang: Storage.get("ek_site_lang") },
      })
      .then((response) => {
        this.CouponContent = response.data.CouponContent;
      })
      .catch((error) => {
        console.log(error);
      });
  },
  mounted: function () {
    // 回頂端
    $(window).scrollTop(0);
    // 套用Class
    $(".wrapper").addClass("member");
    $(".wrapper").addClass("member-coupon");
    // i18n
    if (Storage.isKey("ek_site_lang")) {
      i18n.locale = Storage.get("ek_site_lang");
    } else {
      i18n.locale = "zh_tw";
    }
    this.local = i18n.locale;
  },
  methods: {
    gotoPay() {
      let that = this;
      if (!that.couponCode) {
        that.$swal({
          heightAuto: false,
          title: that.$t("錯誤"),
          text: that.$t("請輸入商品劵序號"),
          icon: "error",
          allowOutsideClick: false,
          confirmButtonText: that.$t("確定"),
        });
      } else {
        // 顯示請稍候
        that.$swal({
          heightAuto: false,
          title: that.$t("請稍候..."),
          allowOutsideClick: false,
          showConfirmButton: false,
          willOpen: function () {
            that.$swal.showLoading();
          },
        });
        // 進入交易環節
        $.ajax({
          url:
            that.GLOBAL.apiSrc +
            that.GLOBAL.subDirectory +
            "/Htmlv2/CreateOrder",
          type: "post",
          data: {
            ProductType: 99,
            PRId: -1,
            PayType: 2,
            BuyCount: 1,
            CouponCode: that.couponCode,
            platform: "",
            token: Storage.get("ek_login_token"),
          },
          dataType: "json",
          async: false,
          error: function () {
            that.$swal({
              heightAuto: false,
              title: that.$t("錯誤"),
              text: that.$t("訂單建立過程發生錯誤, 請稍後再試一次"),
              icon: "error",
              allowOutsideClick: false,
              confirmButtonText: that.$t("確定"),
            });
          },
          success: function (res) {
            // 判斷結果
            if (res.ok) {
              if (res.CouponOrder) {
                that.$swal({
                  heightAuto: false,
                  title: that.$t("交易完成"),
                  icon: "success",
                  allowOutsideClick: false,
                  confirmButtonText: that.$t("確定"),
                  willClose: function () {
                    // 轉到首頁
                    that.$router.push({
                      name: "OrderInfo",
                      params: { OrderId: res.OrderId },
                    });
                  },
                });
              } else {
                that.$swal({
                  heightAuto: false,
                  title: that.$t("錯誤"),
                  text: "交易類型錯誤, 請稍後再試一次(-1)",
                  icon: "error",
                  allowOutsideClick: false,
                  confirmButtonText: that.$t("確定"),
                });
              }
            } else if (res.error_msg) {
              var error_msg = JSON.parse(res.error_msg);
              if (res.toekn_error) {
                that.$swal({
                  heightAuto: false,
                  title: that.$t("錯誤"),
                  text: error_msg[i18n.locale],
                  icon: "error",
                  allowOutsideClick: false,
                  willClose: function () {
                    // 移除登入資訊
                    Storage.remove("ek_login_token");
                    // 回到首頁
                    that.$router.push({
                      name: "Home",
                      params: {},
                    });
                  },
                });
              } else {
                that.$swal({
                  heightAuto: false,
                  title: that.$t("錯誤"),
                  text: error_msg[i18n.locale],
                  icon: "error",
                  allowOutsideClick: false,
                  confirmButtonText: that.$t("確定"),
                });
              }
            }
          },
        });
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Coupon.vue